import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline support and PWA capabilities.
// When a new version is deployed, the onUpdate callback fires a custom event
// that the app listens for to show a "refresh" notification.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const event = new CustomEvent('sw-update-available', {
      detail: { registration },
    });
    document.dispatchEvent(event);
  },
});

// Auto-check for SW updates when the app comes to foreground.
// This ensures users always get the latest version without needing to close all tabs.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration) {
        registration.update();
      }
    });
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
